// MongoDB-based database implementation (stub)
// Implementations should match the exported functions in kv.ts

// Article type definition
export type Article = {
  id: string;
  title: string;
  content: string;
  topic: string;
  userId: string;
  createdAt: number;
  updatedAt: number;
};
export async function getHistoryFromDb(userId?: string | null) {
  throw new Error('MongoDB not implemented yet')
}
export async function getChatFromDB(id: string, userId: string) {
  throw new Error('MongoDB not implemented yet')
}
export async function removeHistory({ id, path }: { id: string; path: string }) {
  throw new Error('MongoDB not implemented yet')
}
export async function clearHistory() {
  throw new Error('MongoDB not implemented yet')
}
export async function getSharedChat(id: string) {
  throw new Error('MongoDB not implemented yet')
}
export async function shareChat(id: string) {
  throw new Error('MongoDB not implemented yet')
}
export async function disableSharedChat(id: string) {
  throw new Error('MongoDB not implemented yet')
}
export async function saveChat(chat: any) {
  throw new Error('MongoDB not implemented yet')
}
export async function refreshHistory(path: string) {
  throw new Error('MongoDB not implemented yet')
}
export async function getMissingKeys() {
  throw new Error('MongoDB not implemented yet')
}
export async function getHistoryMetaFromDb(userId?: string | null, limit?: number) {
  throw new Error('MongoDB not implemented yet')
}
export async function saveHistoryResult(chatId: string, messages: any[], path_prefix: string) {
  throw new Error('MongoDB not implemented yet')
}
export async function getUserByEmail(email: string) {
  throw new Error('MongoDB getUserByEmail not implemented yet')
}

export async function setUserByEmail(email: string, user: any) {
  throw new Error('MongoDB setUserByEmail not implemented yet')
}

export async function getReferralByCode(referral_code: string) {
  throw new Error('MongoDB getReferralByCode not implemented yet')
}

// GitHub connection functions (stubs for MongoDB)
export async function getGithubConnection(userId: string) {
  throw new Error('MongoDB not implemented yet')
}

export async function saveGithubConnection(userId: string, githubAccessToken: string) {
  throw new Error('MongoDB not implemented yet')
}

export async function deleteGithubConnection(userId: string) {
  throw new Error('MongoDB not implemented yet')
}

export async function validateGithubToken(userId: string) {
  throw new Error('MongoDB not implemented yet')
}

// GitHub App installation functions
export async function getGithubInstallation(orgLogin: string) {
  throw new Error('MongoDB getGithubInstallation not implemented yet')
}

export async function saveGithubInstallation(orgLogin: string, installationId: string) {
  throw new Error('MongoDB saveGithubInstallation not implemented yet')
}

export async function deleteGithubInstallation(orgLogin: string) {
  throw new Error('MongoDB deleteGithubInstallation not implemented yet')
}

// Media Pro functions
export async function saveArticle(article: Omit<Article, 'id' | 'createdAt' | 'updatedAt'>) {
  throw new Error('MongoDB not implemented yet')
}

export async function getUserArticles() {
  throw new Error('MongoDB not implemented yet')
}

export async function getArticleById(id: string) {
  throw new Error('MongoDB not implemented yet')
}

export async function updateArticle(
  id: string, 
  updates: Pick<Article, 'title' | 'content'>
) {
  throw new Error('MongoDB not implemented yet')
}

export async function deleteArticle(id: string) {
  throw new Error('MongoDB not implemented yet')
}

// RBAC functions - MongoDB implementation stubs
export async function createTeam(name: string, ownerId: string, plan: string): Promise<{
  success: boolean;
  team?: any;
  error?: string;
}> {
  throw new Error('MongoDB createTeam not implemented yet')
}

export async function createProject(name: string, teamId: string, ownerId: string, description?: string): Promise<{
  success: boolean;
  project?: any;
  error?: string;
}> {
  throw new Error('MongoDB createProject not implemented yet')
}

export async function getUserTeams(userId: string): Promise<any[]> {
  throw new Error('MongoDB getUserTeams not implemented yet')
}

export async function getTeamProjects(teamId: string): Promise<any[]> {
  throw new Error('MongoDB getTeamProjects not implemented yet')
}

export async function generateReferral(
  issuedBy: string,
  type: string,
  scopes: string[],
  targetTeamId?: string,
  targetProjectId?: string,
  maxUses?: number,
  expiresAt?: string
): Promise<{
  success: boolean;
  referral?: any;
  error?: string;
}> {
  throw new Error('MongoDB generateReferral not implemented yet')
}

export async function redeemReferral(code: string, userId: string): Promise<{
  success: boolean;
  teamId?: string;
  projectId?: string;
  error?: string;
}> {
  throw new Error('MongoDB redeemReferral not implemented yet')
}

export async function createDefaultTeamAndProject(userId: string): Promise<{
  success: boolean;
  teamId?: string;
  projectId?: string;
  error?: string;
}> {
  throw new Error('MongoDB createDefaultTeamAndProject not implemented yet')
}

// TODO: SYSTEM_ROLES constant export commented out due to "use server" compatibility
// export const SYSTEM_ROLES = [
//   {
//     name: 'super_admin',
//     scopes: ['*'],
//     description: 'Full system access',
//     isSystemRole: true
//   },
//   {
//     name: 'team_admin', 
//     scopes: ['team:read', 'team:write', 'team:manage_members', 'project:create', 'project:read', 'project:write', 'project:manage_members'],
//     description: 'Team administration',
//     isSystemRole: true
//   },
//   {
//     name: 'project_admin',
//     scopes: ['project:read', 'project:write', 'project:manage_members'],
//     description: 'Project administration', 
//     isSystemRole: true
//   },
//   {
//     name: 'member',
//     scopes: ['project:read', 'team:read'],
//     description: 'Basic member access',
//     isSystemRole: true
//   }
// ];
